import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import FormWhatsApp from "./FormWhatsApp";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import TableWhatsApp from "./TableWhatsApp";
import ButtonIcon from "../../../Buttons/ButtonIcon";
import { BsWhatsapp } from "react-icons/bs";

const WhatsApp = ({ eventDetails, token, userID, isLoading }) => {
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const canvasWidth = isMobile ? "100%" : 400;

  const key = ["allWhatsApp", eventDetails?._id];
  const {
    data: getWhatsApp,
    error: errorGetWhatsApp,
    isLoading: isLoadingGetWhatsApp,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}communication/whatsapp/${eventDetails?._id}`,
    token,
    {
      enabled: !!eventDetails?._id,
    }
  );

  const toggleWhatsApp = () => {
    setIsWhatsAppOpen(!isWhatsAppOpen);
  };

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.headerSection}>
        <h1 style={styles.mainTitle}>WhatsApp</h1>
        <p style={styles.subtitle}>
          Manage and send WhatsApp messages to your attendees. Reach your users
          instantly with personalized messages, updates, and reminders delivered
          directly to their WhatsApp.
        </p>
      </div>

      {/* Send WhatsApp Button */}
      <div style={styles.buttonContainer}>
        <button
          onClick={toggleWhatsApp}
          style={styles.sendWhatsAppButton}
          type="button"
        >
          <BsWhatsapp size={isMobile ? 18 : 14} />
          <span>Send WhatsApp</span>
        </button>
      </div>

      {/* Table Section */}
      <div style={styles.tableContainer}>
        <TableWhatsApp
          userID={userID}
          token={token}
          eventID={eventDetails?._id}
          myEmail={getWhatsApp?.data}
        />
      </div>

      <OffCanvas
        isOffcanvasOpen={isWhatsAppOpen}
        title="Send WhatsApp"
        body={
          <FormWhatsApp
            setIsWhatsAppOpen={setIsWhatsAppOpen}
            userId={userID}
            token={token}
            eventID={eventDetails?._id}
            eventDetails={eventDetails}
          />
        }
        toggleSaveChanges={toggleWhatsApp}
        directionOffCanvas="end"
        widthOffCanvas={canvasWidth}
      />

      <style>{`
        @media (max-width: 768px) {
          .whatsapp-container {
            padding: 16px 12px !important;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 20px !important;
          }
          
          .subtitle {
            font-size: 13px !important;
          }
        }
      `}</style>
    </div>
  );
};

// Professional Styles
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    padding: "24px 20px",
    boxSizing: "border-box",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
  },
  headerSection: {
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "2px solid #e9ecef",
  },
  mainTitle: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#111827",
    margin: "0 0 8px 0",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
    lineHeight: "1.6",
    maxWidth: "800px",
  },
  buttonContainer: {
    marginBottom: "24px",
  },
  sendWhatsAppButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "12px 24px",
    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)",
    height: "48px",
  },
  tableContainer: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    border: "1px solid #e5e7eb",
  },
};

export default WhatsApp;